import installer from '@aspectus/vue-route-installer'

import {
  createRoutes as createUserRoutes,
} from '@app/Seller/routes'

import {
  route,
  prefixRoutes,
} from '@app/Routing/helpers'

const CabinetInstaller = () => import('@app/Seller')
const Cabinet = () => import('@app/Seller/Views/Cabinet')

export function createRoutes(options) {
  const { Vue } = options
  return [
    route('', installer(Cabinet, CabinetInstaller, Vue), {}, {
      children: [
        prefixRoutes('', createUserRoutes(options), {}),
      ],
    }),
  ]
}
